import TopUpImage from '../../assets/images/topup.webp';
import NumberOneCircleIcon from '../../components/shared/Icons/NumberOneCircleIcon';
import NumberTowCircleIcon from '../../components/shared/Icons/NumberTowCircleIcon';
import NumberThreeCircleIcon from '../../components/shared/Icons/NumberThreeCircleIcon';
import InstructionsScreen from '../../components/shared/InstructionsScreen/InstructionsScreen';

export default function FawryInstructionsPage({
  organization: organizationCode,
}) {
  return (
    <InstructionsScreen
      image={TopUpImage}
      title="How to add cash with Fawry"
      organizationCode={organizationCode}
      instructions={[
        {
          icon: <NumberOneCircleIcon />,
          title: 'Swipe your card at any Fawry POS',
        },
        {
          icon: <NumberTowCircleIcon />,
          title:
            'Tell the cashier you wish to make a cash deposit - code {fawry code} - and give them your cash',
        },
        {
          icon: <NumberThreeCircleIcon />,
          title: 'Your money will be added to your {card name} account balance',
        },
      ]}
    />
  );
}
